import { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", msg: "" });
    try {
      if (!form.name || !form.email || !form.message) {
        setStatus({ state: "error", msg: "Name, email & message are required." });
        return;
      }
      if (!/^\S+@\S+\.\S+$/.test(form.email)) {
        setStatus({ state: "error", msg: "That email looks a little off." });
        return;
      }
      await axios.post(`${API}/contact`, form);
      setStatus({ state: "success", msg: "Message received. I\u2019ll respond within 48 hours." });
      setForm({ name: "", email: "", company: "", message: "" });
    } catch {
      setStatus({ state: "error", msg: "Something broke on my end. Try again, or email directly." });
    }
  };

  return (
    <section
      id="contact"
      data-testid="contact-footer-section"
      className="bg-[#111111] text-[#F2EFE9] px-4 md:px-8 lg:px-12 py-20 md:py-32 hard-border-t"
    >
      <div className="font-mono-s text-[11px] tracking-[0.3em] uppercase text-[#F2EFE9]/60 mb-4">
        § 08 — Get in Touch
      </div>
      <h2 className="font-anton uppercase text-6xl md:text-[10vw] leading-[0.88]">
        Ready to bring
        <br />
        your
        <span className="font-cormorant italic text-[#D83127] font-semibold"> vision </span>
        to life?
      </h2>
      <p className="font-cormorant italic text-xl md:text-2xl mt-6 max-w-2xl text-[#F2EFE9]/85">
        Brand overhaul, growth engine, activation, or a focused strategic consult — available for
        engagements based out of Los Angeles or Chicago.
      </p>

      <form
        onSubmit={onSubmit}
        className="mt-12 grid grid-cols-12 gap-5 md:gap-6"
        data-testid="contact-form"
        noValidate
      >
        <div className="col-span-12 md:col-span-6">
          <label htmlFor="c-name" className="font-mono-s text-[11px] tracking-[0.25em] uppercase text-[#F2EFE9]/70">
            01 — Your name*
          </label>
          <input
            id="c-name"
            value={form.name}
            onChange={onChange("name")}
            data-testid="contact-input-name"
            className="w-full bg-transparent border-b border-[#333333] focus:border-[#D83127] outline-none font-anton uppercase text-3xl md:text-4xl py-3 tracking-wide"
            autoComplete="name"
          />
        </div>

        <div className="col-span-12 md:col-span-6">
          <label htmlFor="c-email" className="font-mono-s text-[11px] tracking-[0.25em] uppercase text-[#F2EFE9]/70">
            02 — Email*
          </label>
          <input
            id="c-email"
            type="email"
            value={form.email}
            onChange={onChange("email")}
            data-testid="contact-input-email"
            className="w-full bg-transparent border-b border-[#333333] focus:border-[#D83127] outline-none font-anton uppercase text-3xl md:text-4xl py-3 tracking-wide"
            autoComplete="email"
          />
        </div>

        <div className="col-span-12 md:col-span-6">
          <label htmlFor="c-company" className="font-mono-s text-[11px] tracking-[0.25em] uppercase text-[#F2EFE9]/70">
            03 — Company / project (optional)
          </label>
          <input
            id="c-company"
            value={form.company}
            onChange={onChange("company")}
            data-testid="contact-input-company"
            className="w-full bg-transparent border-b border-[#333333] focus:border-[#D83127] outline-none font-anton uppercase text-3xl md:text-4xl py-3 tracking-wide"
          />
        </div>

        <div className="col-span-12">
          <label htmlFor="c-message" className="font-mono-s text-[11px] tracking-[0.25em] uppercase text-[#F2EFE9]/70">
            04 — What are we building?*
          </label>
          <textarea
            id="c-message"
            rows={5}
            value={form.message}
            onChange={onChange("message")}
            data-testid="contact-input-message"
            className="w-full bg-transparent border-b border-[#333333] focus:border-[#D83127] outline-none font-cormorant italic text-2xl md:text-3xl py-3 leading-snug resize-none"
          />
        </div>

        <div className="col-span-12 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 pt-2">
          <button type="submit" className="btn-offset" data-testid="contact-submit" disabled={status.state === "loading"}>
            {status.state === "loading" ? "Sending…" : "Send Message →"}
          </button>

          <div className="font-mono-s text-xs tracking-[0.2em] uppercase text-[#F2EFE9]/60">
            or email{" "}
            <a
              href="mailto:hello@jpkuster.com"
              className="link-underline text-[#D83127]"
              data-testid="contact-email-link"
            >
              hello@jpkuster.com
            </a>
          </div>

          {status.state === "success" && (
            <div
              className="font-cormorant italic text-lg text-[#F2EFE9]"
              data-testid="contact-status-success"
            >
              ✓ {status.msg}
            </div>
          )}
          {status.state === "error" && (
            <div className="font-mono-s text-xs uppercase tracking-[0.2em] text-[#D83127]" data-testid="contact-status-error">
              ✕ {status.msg}
            </div>
          )}
        </div>
      </form>
    </section>
  );
}
